module.exports = __webpack_public_path__ + "img/rhombus.fc08cb03.svg";